import { Box } from '@mui/material'

export default Box
